// extracted by mini-css-extract-plugin
export default {"UserHeading":"UserScreen_UserHeading__TSI+S","Icon":"UserScreen_Icon__Kexy1"};